import axios, { AxiosError, AxiosResponse } from "axios";
import { showToast } from "./index";
// import { errorMessage } from "./Constants";

const Instance = axios.create({
  baseURL: "/",
  timeout: 10000,
  withCredentials: true,
});

Instance.interceptors.request.use(
  (config) => {
    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    if (isFormData) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    } else if (!config.headers["Content-Type"] && !config.headers["content-type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

Instance.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data?.resCode === "100") {
      const errorMsg = data.resMessage || "Error occurred";
      showToast(errorMsg, "error", "error");
      const error = new Error(errorMsg);
      error.response = { data };
      return Promise.reject(error);
    }
    if (data?.resCode === "401") {
      const errorMsg = (typeof data.resMessage === 'string' ? data.resMessage : "Session expired") + " . Please login again";
      showToast(errorMsg, "error", "error");
      localStorage.clear();
      sessionStorage.clear();
      document.cookie = "tokenId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
      const error = new Error(errorMsg);
      error.response = { data };
      return Promise.reject(error);
    }
    if (data?.resCode === "400") {
      Instance.post("/user/logout", {
      })
        .catch(() => { /* Ignore logout failure during redirect suppression */ })
        .finally(() => {
          localStorage.clear();
          sessionStorage.clear();
          // Remove tokenId cookie
          document.cookie = "tokenId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.href = "/";
        });
      const errorMsg = data.resMessage || "Unauthorized access";
      const error = new Error(errorMsg);
      error.response = { data };
      return Promise.reject(error);
    }

    return response;
  },
  (error) => {
    const response = error?.response;
    if (response) {
      const errorData = response?.data?.errors;
      const status = response?.status;
      if (status === 401 || status === 403) {
        localStorage.clear();
        sessionStorage.clear();
        document.cookie = "tokenId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = "/";
      } else if (status === 400 && errorData) {
        if (typeof errorData === 'object' && !Array.isArray(errorData)) {
          Object.keys(errorData).forEach((key) => {
            const val = errorData[key];
            const msg = Array.isArray(val) ? val[0] : val;
            if (msg) showToast(msg, "error", msg);
          });
        } else if (Array.isArray(errorData)) {
          errorData.forEach((err) => {
            const msg = typeof err === 'object' ? (err.message || JSON.stringify(err)) : err;
            showToast(msg, "error", msg);
          });
        } else {
          showToast(errorData, "error", "error");
        }
      } else if (status >= 500) {
        showToast(
          "Server Error. Please try after some time.",
          "error",
          "Server Error. Please try after some time."
        );
      }
    }
    return Promise.reject(error);
  }
);
export default Instance;
